import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import VisitMap from "../components/VisitMap";

function Homepage() {
  return (
    <main className="bg-white">
      <Hero />
      <Services />
      <VisitMap />
    </main>
  );
}

export default Homepage;
